import { render, staticRenderFns } from "./GdprOverlay.vue?vue&type=template&id=5f840897&"
import script from "./GdprOverlay.js?vue&type=script&lang=js&"
export * from "./GdprOverlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f840897')) {
      api.createRecord('5f840897', component.options)
    } else {
      api.reload('5f840897', component.options)
    }
    module.hot.accept("./GdprOverlay.vue?vue&type=template&id=5f840897&", function () {
      api.rerender('5f840897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/GdprOverlay/GdprOverlay.vue"
export default component.exports